import AbstractComponent from './AbstractComponent';

class Reveal extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.handleIntersection = this.handleIntersection.bind(this);
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
  }

  initializeBeforeEvents() {
    this.ui.$reveals.forEach(($reveal) => {
      $reveal.style.opacity = 0;
      $reveal.style.transform = `translateY(30px)`;
    });

    const isFull = this.ui.$element.classList.contains('reveal--full');

    this.observer = new IntersectionObserver(this.handleIntersection, {
      threshold: 0.0,
      rootMargin: `0px 0px ${isFull ? '0px' : '-25%'} 0px`,
    });
  }

  getUI() {
    const ui = super.getUI();
    ui.$reveals = [...ui.$element.querySelectorAll('.reveal__item')];
    return ui;
  }

  events(listen) {
    super.events(listen);
    const observe = listen ? 'observe' : 'unobserve';
    this.ui.$reveals.forEach(($item) => this.observer[observe]($item));
  }

  handleTransitionEnd() {
    [
      'opacity',
      'transform',
      'transition-property',
      'transition-duration',
      'transition-delay',
      'transition-timing-function',
      'will-change',
    ].forEach((key) => event.target.style.removeProperty(key));
    event.target.removeEventListener('transitionend', this.handleTransitionEnd);
  }

  handleIntersection([entry]) {
    if (entry.isIntersecting === false) return;

    this.ui.$reveals.forEach(($reveal, i) => {
      // Style props
      const duration = 0.6;
      const stagger = 0.1;
      const delay = 0.2 + stagger * i;

      // Re-set default CSS transition
      $reveal.style.removeProperty('transition');

      // Remove props on TransitionEnd
      $reveal.addEventListener('transitionend', this.handleTransitionEnd);

      Object.assign($reveal.style, {
        transform: `translateY(0%)`,
        willChange: 'transform,opacity',
        transitionProperty: `opacity,transform`,
        transitionDuration: `${duration}s`,
        transitionTimingFunction: 'cubic-bezier(0.250, 0.460, 0.450, 0.940)',
        transitionDelay: `${delay}s`,
        opacity: 1,
      });
    });
  }
}

export default Reveal;
